import SkeletonTable from "@/components/SkeletonTable"
import { getListKonsentrasiProdi } from "@/services/getData"
import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"

export default function MasterKonsentrasiProdiPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listKonsentrasiProdi"],
    queryFn: getListKonsentrasiProdi,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
